<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <template v-if="data.offer.cost">
      <Teleport
        defer
        to="#portal-modal-header-target"
      >
        <h3 class="cf-title cf-title--3 cf-title--brand-primary">
          {{ data.offer.cost }} {{ loyalty.currency.pluralShortNameUpperCase }}
        </h3>
      </Teleport>
    </template>

    <div
      v-if="data.offer.couponDetailsImageUrl"
      class="cf-image-container cf-image-container--bleed"
    >
      <img
        alt="coupon image"
        :src="data.offer.couponDetailsImageUrl"
        class="cf-image"
        onerror="this.src='/images/image-not-found.png';"
      >
    </div>

    <div :class="['cf-flex cf-flex--column cf-flex--gap-16 cf-text-align-left', { 'cf-padding-top-16': !data.offer.couponDetailsImageUrl }]">
      <div class="cf-flex cf-flex--column cf-flex--gap-12 cf-text-align-left">
        <h3 class="cf-title cf-title--2">
          {{ data.offer.title }}
        </h3>

        <p class="cf-subtitle cf-subtitle--2">
          {{ data.offer.description }}
        </p>
      </div>

      <template v-if="data.offer.finePrint">
        <cf-title-separator :omit-title="true" />

        <div class="cf-flex cf-flex--column cf-flex--gap-12">
          <h4 class="cf-title cf-title--4 cf-title--gray">
            Terms & Conditions
          </h4>

          <cf-formatted-content
            v-if="data.offer.finePrint"
            class="cf-subtitle cf-subtitle--2"
            :content="data.offer.finePrint"
          />

          <p
            v-if="data.offer.endDate"
            class="cf-subtitle cf-subtitle--3 cf-subtitle--heavy cf-text-italics"
          >
            Expires {{ $formatDate(data.offer.endDate) }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfFormattedContent from '@/view/components/globals/cf-formatted-content/index.vue';


  export default {
    name: 'OfferDetails',

    components: {
      CfTitleSeparator,
      CfFormattedContent
    },

    props: {
      data: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('offers', ['loyalty'])
    }
  };
</script>
